class GeroSnizeEvents {
  static waitFor(onReady) {
    if (null != window.Searchanise && null != window.Searchanise.$) {
      onReady(window.Searchanise.$);
      return;
    }
    window.setTimeout(() => GeroSnizeEvents.waitFor(onReady), 100);
  }

  static onDataRequest(handler) {
    GeroSnizeEvents.waitFor(($) => {
      $(document).on("Searchanise.DataRequestEnd", (event, type, params, data) => handler(type, data));
    });
  }

  static onResults(handler) {
    GeroSnizeEvents.waitFor(($) => {
      $(document).on("Searchanise.ResultsUpdated", (event, container) => handler(container[0]));
    });
  }

  static onAutocomplete(handler) {
    GeroSnizeEvents.waitFor(($) => {
      $(document).on("Searchanise.AutocompleteUpdated", (event, input, container) => handler(container[0]));
    });
  }
}
